import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changeProteinTab'
})
export class ChangeProteinTabPipe implements PipeTransform {

  name;

  transform(value: any): any {

    if(value == "basicInfo"){
      this.name = "Basic Info";
    }
    else if(value == "sequence"){
      this.name = "Sequence";
    }
    else if(value == "organism"){
      this.name = "Organism";
    }
    else if(value == "keywords"){
      this.name = "Keywords";
    }
    else if(value == "feature"){
      this.name = "Feature";
    }
    else if(value == "dbRef"){
      this.name = "DB Reference";
    }
    else if(value == "cited"){
      this.name = "Cited";
    }

    return this.name;
  }

}
